// La selfie del chofer que muestra el panel. La carga el chofer desde la app
// (PUT /v2/drivers/:id/extra) y el servidor acepta cualquier texto: una URL de
// otro servidor se pediría desde el navegador del coordinador en cada carga
// de la ficha (y sabría quién la mira y cuándo). Solo se muestran las del
// Storage de la app y las imágenes en línea chicas; si no, las iniciales.
const FIREBASE = "https://firebasestorage.googleapis.com/v0/b/lynx-mobile-7d96b.firebasestorage.app/";
const DATA_MAX = 300_000;

export const selfieSegura = (s: string | null | undefined): s is string =>
  !!s && (s.startsWith(FIREBASE) || (/^data:image\/(png|jpe?g|webp|gif);base64,/.test(s) && s.length <= DATA_MAX));
